import { axiosRequest } from '@/util/axios-request'

// 注册
export const registerApi = data => {
  return axiosRequest({
    url: '/auth/web/register',
    errorMessage: true,
    data
  })
}
// 获取注册短信验证码
export const getRegisterShortCode = data => {
  return axiosRequest({
    url: '/auth/app/smsCaptcha',
    errorMessage: true,
    data
  })
}

// 登录
export const login = data => {
  return axiosRequest({
    url: '/auth/web/login',
    errorMessage: true,
    data
  })
}

// 创建公司
export const companyNew = data => {
  return axiosRequest({
    url: '/web/company/new',
    errorMessage: true,
    data
  })
}

// 获取二维码
export const getQrCode = data => {
  return axiosRequest({
    url: '/auth/qr/code',
    errorMessage: true,
    method: 'GET',
    params: data
  })
}

// 二维码扫码状态查询
export const QrStatus = data =>
  axiosRequest({
    url: '/auth/qr/status',
    errorMessage: true,
    data
  })

// 公司登录
export const companyLogin = data => {
  return axiosRequest({
    url: '/web/company/signin',
    errorMessage: true,
    data
  })
}

// 获取个人信息
export const getUserInfo = data => {
  return axiosRequest({
    url: '/auth/user/info',
    data
  })
}

// 公司信息
export const companyinfo = data => {
  return axiosRequest({
    url: '/web/company/info',
    data
  })
}

// 国家
export const countries = data => {
  return axiosRequest({
    url: '/web/company/countries',
    data
  })
}
// 行业
export const companyIndustries = data => {
  return axiosRequest({
    url: '/web/company/industries',
    data
  })
}

// 规模
export const companySize = data =>
  axiosRequest({
    url: '/web/company/size',
    data
  })
